import { NavLink } from "react-router-dom";

const Navbar = ({ colorBg }) => {
	return (
		<nav className={colorBg === "black" ? " text-[2rem] bg-grey text-white" : " text-[2rem] bg-transparent text-white"}>
			<div className="flex flex-row justify-around items-center h-16">
				<NavLink className={({ isActive, isPending }) => (isPending ? "" : isActive ? "nav-stroke" : "")} to="/">
					<img className="w-16" src="./assets/wbrand-logo.png" alt="" />
				</NavLink>
				<NavLink className={({ isActive, isPending }) => (isPending ? "" : isActive ? "nav-stroke" : "")} to="/">
					<h1 id="home">عنى</h1>
				</NavLink>
				<NavLink className={({ isActive, isPending }) => (isPending ? "" : isActive ? "nav-stroke" : "")} to="/gallery">
					<h1 id="photos">الصور</h1>
				</NavLink>
				<NavLink className={({ isActive, isPending }) => (isPending ? "" : isActive ? "nav-stroke" : "")} to="/contact">
					<h1 id="contact">تواصل</h1>
				</NavLink>
			</div>
		</nav>
	);
};

export default Navbar;
